import { createFileRoute } from "@tanstack/react-router";
import ImpersonarPage from "../-pages/Impersonar";

export const Route = createFileRoute("/(public)/impersonar")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ImpersonarPage />;
}
